/* global axios */

export const AOIKUMO_PROVIDER = 'aoikumo';

export const aoikumoUrl = (accountId, path) =>
  `/api/v1/accounts/${accountId}/proxy/knowledge/accounts/${accountId}/integrations/${AOIKUMO_PROVIDER}${path}`;

const UNREACHABLE_STATUSES = [429, 502, 504];
// The backend's own wording for the same cases. Matched as well as the status,
// so the error is still recognised if the status is ever lost on the way.
const UNREACHABLE_TEXT = /^Aoikumo (rate limit reached|error|did not respond)/i;

// FastAPI validation errors arrive as `[{ loc, msg, type }]`.
const detailFromValidation = detail =>
  detail
    .map(item => (typeof item === 'string' ? item : item?.msg))
    .filter(Boolean)
    .join('; ');

// Turns an axios error into `{ status, code, message }`. `message` is always
// the backend's `detail` text as sent (so it can be quoted when reporting an
// issue), including for 429 / 502 / 504. The backend sends `detail` as a
// string, as `{ code, message }` for admin_required, or as a list for 422.
export const parseAoikumoError = error => {
  const status = error?.response?.status;
  const detail = error?.response?.data?.detail;
  const detailText = typeof detail === 'string' ? detail : null;
  if (
    UNREACHABLE_STATUSES.includes(status) ||
    (detailText && UNREACHABLE_TEXT.test(detailText))
  ) {
    return { status, code: 'unreachable', message: detailText };
  }
  if (Array.isArray(detail)) {
    return {
      status,
      code: null,
      message: detailFromValidation(detail) || null,
    };
  }
  if (detail && typeof detail === 'object') {
    return { status, code: detail.code || null, message: detail.message };
  }
  if (typeof detail === 'string') {
    return { status, code: null, message: detail };
  }
  return { status, code: null, message: null };
};

export const aoikumoPatchBranch = (accountId, branchId, body) =>
  axios.patch(
    `/api/v1/accounts/${accountId}/proxy/knowledge/v2/accounts/${accountId}/branches/${branchId}`,
    body
  );

export const aoikumoGet = (accountId, path = '') =>
  axios.get(aoikumoUrl(accountId, path));
export const aoikumoPost = (accountId, path, body) =>
  axios.post(aoikumoUrl(accountId, path), body);
export const aoikumoPatch = (accountId, path, body) =>
  axios.patch(aoikumoUrl(accountId, path), body);
export const aoikumoDelete = (accountId, path) =>
  axios.delete(aoikumoUrl(accountId, path));
